import React from 'react';
import EventList from '../../views/Events/EventList';
import { useEventLogs } from '../../services/Firestore/Resources';

export const AssetEvents = ({ assetId }) => {
  const [eventLogs, eventLogsLoading] = useEventLogs({
    limit: 250,
    where: [{ field: 'aggregateId', op: '==', value: assetId }],
    orderBy: [['timestamp', 'desc']],
  });

  if (eventLogsLoading) {
    return <p>Loading events</p>;
  }
  return <EventList events={eventLogs} />;
};
